import { render } from "./RocksWin.vue?vue&type=template&id=0ca37499"
import script from "./RocksWin.vue?vue&type=script&lang=js"
export * from "./RocksWin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__